const cache: { [key: string]: { promise: Promise<any>; dependency: any } } = {}

export const isDependencyLoaded = (key: string) => {
  return !!cache[key]
}

export const getDependency = (key: string) => {
  return cache[key]?.dependency
}

export const importDependency = async <T = any, R = T>(
  key: string,
  getLoadPromise: () => Promise<any>,
  callback?: (arg: T) => Promise<unknown>
): Promise<R | null> => {
  try {
    if (cache[key]) {
      if (!cache[key].dependency) {
        await cache[key].promise
      }

      const cacheDependency = cache[key].dependency as T
      if (callback) {
        return (await callback(cacheDependency)) as R
      }
      return cacheDependency as unknown as R
    }

    const loadPromise = getLoadPromise()

    cache[key] = {
      promise: loadPromise,
      dependency: null,
    }

    const loadedData = await cache[key].promise
    cache[key].dependency = (loadedData?.default || loadedData) as T

    if (callback) {
      return (await callback(cache[key].dependency)) as R
    }
    return cache[key].dependency as unknown as R
  } catch (e: unknown) {
    console.error(`importDependency::: Fail to load data for key ${key}`)
  }
  return null
}
